(function (window, $) {
    var locationName;
    var keycodes = [9, 13, 37, 38, 39, 40];

    var typeahead;
    var input;

    if ($('#living-location-typeahead-template').length > 0) {
        $('#living-location-typeahead-template').on('cloned', initTypeahead);
    }

    initTypeahead();

    function initTypeahead() {
        typeahead = $('#living-location-typeahead');
        input = $('#hidden-location-id');

        if (!typeahead.length) {
            return;
        }

        var livingLocations = new Bloodhound({
            datumTokenizer: Bloodhound.tokenizers.obj.whitespace('name'),
            queryTokenizer: Bloodhound.tokenizers.whitespace,
            prefetch: {
                url: typeahead.attr('data-prefetch-url'),
                ttl: 60
            }
        });

        livingLocations.initialize();

        typeahead.typeahead({
            highlight: true,
            limit: 20
        }, {
            name: 'livingLocations',
            displayKey: 'full_name',
            source: livingLocations.ttAdapter(),
            autoSelect: true
        });

        typeahead.on('typeahead:selected', selected);
        typeahead.on('typeahead:autocompleted', autocompleted);
        typeahead.on('typeahead:cursorchanged', cursorchanged);
        typeahead.on('keydown', checkaccuracy);
    }

    function selected(event, suggestion, dataset) {
        typeahead.attr('selected-location-id', suggestion.id);
        typeahead.attr('selected-location-name', suggestion.full_name);
        setid();
    }

    function autocompleted(event, suggestion, dataset) {
        typeahead.attr('selected-location-id', suggestion.id);
        typeahead.attr('selected-location-name', suggestion.full_name);
        setid();
    }

    function cursorchanged(event, suggestion, dataset) {
        typeahead.attr('selected-location-id', suggestion.id);
        typeahead.attr('selected-location-name', suggestion.full_name);
        setid();
    }

    function checkaccuracy(event) {
        if (keycodes.indexOf(event.keyCode) === -1) {
            if (locationName != typeahead.val()) {
                if (input.val() != "") {
                    typeahead.val('');
                }

                input.val('');
                typeahead.css("background-color", "transparent");;
            }
        }
    }

    function setid() {
        var id = typeahead.attr('selected-location-id');
        var locationName = typeahead.attr('selected-location-name');

        input.val(id);
        typeahead.css("background-color", "#0dff00");;
    }
})(window, jQuery);
